import { useMemo } from "react";
import { IBM_Plex_Mono as ibmPlexMono } from 'next/font/google';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import CopyButton from "@/components/CopyButton";

const mono = ibmPlexMono({
  subsets: ['latin'],
  weight: '400',
});

type PrettyJsonProps = {
  stringifiedJson: string;
  noBorder?: boolean;
};
const PrettyJson: React.FC<PrettyJsonProps> = ({ stringifiedJson, noBorder }) => {
  const prettifiedJson = useMemo(() => {
    let retVal = stringifiedJson;

    try {
      retVal = JSON.stringify(JSON.parse(stringifiedJson), null, 2);
    } catch {
      // When the response isn't proper json
      retVal = stringifiedJson;
    }

    return retVal;
  }, [stringifiedJson]);

  return (
    <div
      style={{
        border: noBorder ? 'none' : '1px solid var(--color-gray-25)',
        borderRadius: noBorder ? 0 : 4,
        position: 'relative',
      }}
    >
      <CopyButton text={prettifiedJson} style={{ position: 'absolute', right: 'var(--spacer-sm)', top: 'var(--spacer-sm)' }}>
        Copy
      </CopyButton>
      <SyntaxHighlighter
        language="json"
        customStyle={{
          backgroundColor: 'var(--color-gray-0)',
          borderRadius: 4,
          fontSize: 14,
          margin: 0,
        }}
        wrapLongLines
        codeTagProps={{ style: mono.style }}
      >
        {prettifiedJson}
      </SyntaxHighlighter>
    </div>
  );
};

export default PrettyJson;
